import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  isUppercase?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, isUppercase = true, ...labelProps },
  forwardedRef
) {
  return (
    <label
      ref={forwardedRef}
      className={cn(
        'text-xs font-bold text-zoomuted tracking-wider',
        isUppercase === true ? 'uppercase' : 'normal-case',
        className
      )}
      {...labelProps}
    />
  );
});
